import { render, staticRenderFns } from "./upgradeCase.vue?vue&type=template&id=05d3aeee&scoped=true&"
import script from "./upgradeCase.vue?vue&type=script&lang=js&"
export * from "./upgradeCase.vue?vue&type=script&lang=js&"
import style0 from "./upgradeCase.vue?vue&type=style&index=0&id=05d3aeee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3aeee",
  null
  
)

export default component.exports